<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    div.wrap-profile-edit
      ModuleProfileEdit(ref="moduleProfileEdit"
        v-if="user" :user="user")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-profile-edit {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header.vue'
import ModuleProfileEdit from '@/components/module/ModuleProfileEdit'

export default {
  components: {
    Auth, Header, ModuleProfileEdit
  },
  data () {
    return {
      headerContent: {},
      user: null,
      isSaving: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
      this.user = await database.userCollection().findById(this.uid)
      this.headerContent = {
        title: 'Home',
        left: {
          icon: 'mdi-close', to: `/profile/${this.uid}`
        },
        right: {
          label: '保存', color: this.pallete.$active_color,
          action: this.save
        }
      }
    },
    async save () {
      if (this.isSaving) return

      this.isSaving = true
      this.headerContent.right.color = this.pallete.$secondary_text_color

      const moduleProfileEdit = this.$refs.moduleProfileEdit
      const updateParams = {
        iconPhotoURL: moduleProfileEdit.iconPhotoURL,
        firstName: moduleProfileEdit.firstName,
        lastName: moduleProfileEdit.lastName,
        displayName: `${moduleProfileEdit.lastName}${moduleProfileEdit.firstName}`,
        profile: moduleProfileEdit.profile,
        updatedAt: new Date()
      }

      console.log('save', moduleProfileEdit)

      await database.userCollection().update(this.uid, updateParams)
      
      this.isSaving = false
      this.headerContent.right.color = this.pallete.$active_color

      alert('保存しました')
      this.$router.push(`/profile/${this.user.uid}`)
    }
  }
}
</script>
